$( document ).ready(function() {
  
  // SEARCH
  $('.search-input-text').focus(function(){  
    $(this).addClass('focus');
    $("#logo").addClass("move");
  });
  $(".search-input-text").blur(function(){
    $(this).removeClass('focus');
    $("#logo").removeClass("move");
  });
  var value = $('.search-input-text').val();
  if (value !== '') {
    $('.search-input-text').addClass('superfocus');
    $("#logo").addClass("supermove");
  }
  $('.search-input-text').keyup(function () {
    var value = jQuery(this).val();
    if (value !== '') {
      $('.search-input-text').addClass('superfocus');
      $("#logo").addClass("supermove");
    } else {
      $('.search-input-text').removeClass('superfocus');
      $("#logo").removeClass("supermove");
    }
  });

  // HOMEPAGE RANDOM POSITIONING FEATURED PRODUCTS
  var classes = ["top", "center", "bottom"];
  $(".featured-product-silhouette").each(function(){
      $(this).addClass(classes[~~(Math.random()*classes.length)]);
  });
  
  // FADE IN/OUT
  window.addEventListener("beforeunload", function () {
    $("body").addClass("fade-out");
  });
  window.addEventListener("pageshow", function() {
    setTimeout(function(){
      $("body").removeClass("fade-out");
    }, 500);
  }, false);
  setTimeout(function(){
    $("body").removeClass("fade-out");
  }, 500);

  // LAZY LOADING
  var L = [].slice.call(document.querySelectorAll('.lazy'));
  if('IntersectionObserver' in window){
    let o = new IntersectionObserver(function(E, observer){
      E.forEach(function(e){
        if(e.isIntersecting){
          let l = e.target;
          if(l.tagName == 'IMG'){
            setTimeout(function(){
              l.src = l.dataset.src;
            }, 500);
          }
          if(l.tagName == 'VIDEO'){
            var P = l.play();
            if(P !== undefined){
              P.catch(error => {
                l.controls = true;
                l.classList.add('no-autoplay');
              });
            }
          }
          setTimeout(function(){
            l.classList.remove('lazy');
          }, 500);
          o.unobserve(l);
        }
      });
    });
    L.forEach(function(l){
      o.observe(l);
    });
  }
    
  // CLICK
  $( ".quick-buy-trigger" ).click(function() {
    $(this).next().show();
    $(this).prev().hide();
  });

  $( ".product" ).hover(
    function() {
    }, function() {
      $( this ).find( ".heart" ).show();
      $( this ).find( ".quick-buy-content" ).hide();
    }
  );

  $( "#mobile-menu-trigger" ).click(function() {
    $("#menu-mobile").toggleClass("show");
    $("#mini-cart").removeClass("active"); 
  });

  // EACH
  $('.product-info').each(function() {
    $($(this).prop('firstChild')).wrap('<h3>');
  });
  
 // PDP MOBILE
  $( ".legal-content.faq h3" ).click(function() {
    $(this).toggleClass("show");
    $(this).next().slideToggle(300);
  });
  
  // QTY PRODUCT
  $( ".minus-quan" ).click(function() {
    var getValue = $("#qty").attr("value")
    getValue = parseFloat(getValue) - 1;
    if (getValue > 0) {
      $("#qty").val(getValue);
      $("#qty").attr("value", getValue);
    }
  });
  $( ".plus-quan" ).click(function() {
    var getValue = $("#qty").attr("value")
    getValue = parseFloat(getValue) + 1;
    $("#qty").val(getValue);
    $("#qty").attr("value", getValue);
  });
  
  // ADD/REMOVE ITEM
  setTimeout(function(){
    /*$('.cart-product-quantity').each(function() {
      var elplus = $(this).find('.plus'),
          elminus = $(this).find('.minus'),
          quantity = $(this).find('input').val(),
          quentityDiv = $(this).find('.quantity-wrap');
      quentityDiv.text(quantity);
      $(this).on('click', '.plus', function(e) {
        incrementValue(e);
      });
      $(this).on('click', '.minus', function(e) {
        decrementValue(e);
      });
    });*/
    $(document).on('click',  '.plus', function(e){
        var quantity = $(this).parent().find('input').val(),
          quentityDiv = $(this).parent().find('.quantity-wrap');
        quentityDiv.text(quantity);
        incrementValue(e);
    });  
    $(document).on('click',  '.minus', function(e){
        var quantity = $(this).parent().find('input').val(),
          quentityDiv = $(this).parent().find('.quantity-wrap');
        quentityDiv.text(quantity);
        decrementValue(e);
    });  
  }, 20);
  // UPDATE CART COUNT
  function updateCartCount() {
    jQuery.getJSON('/cart.js', function(cart) {
      let itemscount = cart.item_count;
      var totalmoney = cart.total_price;
      totalmoney = totalmoney.toString().slice(0,-2);
      var len = totalmoney.length;
      var x = totalmoney.substring(0, len-3) + "," + totalmoney.substring(len-3);
      if(len < 4){
        $("#total-price-minicart").text("$" + totalmoney);
      } else {
        $("#total-price-minicart").text("$" + x);
      }
      if(itemscount == 0){
        $("#mini-cart").removeClass("active");
        $("#cart-trigger").addClass("disabled");
      } else {
        $("#cart-trigger").removeClass("disabled");
      }
      $("#cart-trigger-number").text(itemscount);
    });
  }
  // ADD PRODUCT
  function incrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);
    var id = $(e.target).data('id');
    var maxinv = $(e.target).data("inventory")
    console.log(maxinv);

    if(currentVal >= maxinv) {
      console.log("No more stock");
    } else {
      if (!isNaN(currentVal)) {
        parent.find('input[name="updates[]"]').val(currentVal + 1);
        parent.find('.quantity-wrap').text(currentVal + 1);
        jQuery.post('/cart/change.js', {
          quantity: currentVal + 1,
          id: id
        });
      } else {
        parent.find('input[name="updates[]"]').val(0);
        parent.find('.quantity-wrap').text(0);
        jQuery.post('/cart/change.js', {
          quantity: 0,
          id: id
        });
      }
    }
    
    setTimeout(function(){
      updateCartCount();
    }, 500);
  }
  // REMOVE PRODUCT
  function decrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var cartitem = $(e.target).closest(".mini-cart-item");
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);
    var id = $(e.target).data('id');
    
    if (!isNaN(currentVal) && currentVal > 1) {
      parent.find('input[name="updates[]"]').val(currentVal - 1);
      parent.find('.quantity-wrap').text(currentVal - 1);
      jQuery.post('/cart/change.js', {
        quantity: currentVal - 1,
        id: id
      });
    } else {
      parent.find('input[name="updates[]"]').val(0);
      parent.find('.quantity-wrap').text(0);
      jQuery.post('/cart/change.js', {
        quantity: 0,
        id: id
      });
      cartitem.remove();
    }
    setTimeout(function(){
      updateCartCount();
    }, 500);
  }
  // PDP MOBILE
  $( ".collapse-mobile" ).click(function() {
    $("#product-info").toggleClass("hide");
  });
  
  // TOGGLE MINICART
  $( ".close-cart" ).click(function() {
    $( "#mini-cart" ).removeClass("active");
    $( "#menu-container" ).removeClass("show");
    $( "#cart-trigger" ).removeClass("active");
    $("body").removeClass("black-menu");
    $("body").removeClass("cart-active");
    $('#menu-mobile').removeClass('show');
    $("#burger").removeClass("active");
  });
  $( "#cart-trigger" ).click(function() {
    $( "#mini-cart" ).toggleClass("active");
    $( "#menu-container" ).removeClass("show");
    $( "#cart-trigger" ).toggleClass("active");
    $("body").toggleClass("cart-active");
    $('#menu-mobile').removeClass('show');
    $("#burger").removeClass("active");
    $( "#menu-shop" ).removeClass("active");
    $("menu").removeClass("show");
    $("#header").removeClass("active-submenu");
  });

  // SELECT TO RADIO BUTTON
  $('.product-select-homepage').each(function(i, select){
      var $select = $(select);
      $select.find('option').each(function(j, option){
          var $option = $(option);
          // Create a radio
          var $radio = $('<input type="radio" />');
          // Set name and value:
          $radio.attr('name', $select.attr('name')).attr('value', $option.val()).attr('class', 'variant-input');
          // Set checked if the option was selected
          if ($option.attr('selected')) $radio.attr('checked', 'checked').addClass('checked-variant');
          // Set sold-out class if sold-out class was there
          if ( $($option).is( ".sold-out-variant" ) ) {
            $radio.addClass('sold-out-variant').prop( "disabled", true );
          }
          // Insert radio before select box
          $select.before($radio);
          // Insert a label
          $select.before(
            $("<label />").attr('class', 'variant-input-label').attr('for', $select.attr('name')).text($option.text())
          );
      });
      $select.remove();
  });

  // REMOVE SOLD OUT
  setTimeout(function(){
    $( ".variant-input-label" ).each(function( index ) {
      var text = $(this).text();
      $(this).text(text.replace('-sold-out', ''));         
    });
  }, 300);

  // SELECT SIZE
  setTimeout(function(){
    $( ".variant-input" ).each(function( index ) {
      if ( $(this).is( ".checked-variant" ) ) {
        $(this).next().addClass("selected-size-label");
      }
      if ( $(this).is( ".sold-out-variant" ) ) {
        $(this).next().addClass("sold-out-variant-label-last");
      }
    });
    $( ".variant-input-label" ).click(function() {
      $(this).prev().prop( "checked", true );
      $(this).parent().children( ".variant-input-label" ).removeClass("selected-size-label");
      $(this).parent().parent().children(".product-add").children(".addtoca").removeClass("unavailable");
      $(this).addClass("selected-size-label");
    });
  }, 200);

  // DETAILS
  $( ".detail-trigger" ).click(function() {
    $(this).next(".detail-content").toggle();
    $(this).toggleClass("active");
    $( ".detail-trigger" ).not($(this)).removeClass("active");
    $( ".detail-content" ).not($(this).next(".detail-content")).hide();
  });

  // HOVER SHOP MENU
  /*$( "#menu-shop" ).click(function() {
    event.preventDefault();
    $(this).toggleClass("active");
    $("menu").toggleClass("show");
    $("#header").toggleClass("active-submenu");
    $("body").removeClass("cart-active");
    $("#mini-cart").removeClass("active");
  });*/
  $( ".mobile-submenu-trigger" ).click(function() {
    event.preventDefault();
    $(this).toggleClass("active");
    $(this).next(".submenu-mobile-container").slideToggle();
  });
  $( ".has-children" ).hover(
    function() {
      var handle = $(this).data("handle");
      $(this).addClass("active");
      $("#sub-menu-" + handle).addClass("show");
      $("#header").addClass("active-submenu");
      $("body").removeClass("cart-active");
      $("#mini-cart").removeClass("active");
    }, function() {
      $(".menu-link").removeClass("active");
      $(".submenu-container").removeClass("show");
      $("#header").removeClass("active-submenu");
    }
  );
  $( "menu" ).hover(
    function() {
      $(this).addClass("show");
      $("#header").addClass("active-submenu");
      $("body").removeClass("cart-active");
      $("#mini-cart").removeClass("active");
    }, function() {
      $(".menu-link").removeClass("active");
      $(".submenu-container").removeClass("show");
      $("#header").removeClass("active-submenu");
    }
  );
    
});

const windowHeight = document.documentElement.clientHeight;
document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`); 
$( window ).on( "resize", function() {
  const windowHeight = document.documentElement.clientHeight;
  document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`); 
});



$( window ).on( "load", function() {
  if($(".marquee3k").length){
    Marquee3k.init({
      selector: 'marquee3k',
    });        
  }
  // Select the target node
  var target = $('.swym-wishlist-detail-content')[0]; // Make sure to replace 'yourDivId' with the actual ID of your div
  
  // Create an observer instance
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if( $('.react-swipeable-view-container div[aria-hidden="false"] a.swym-more-details-btn').length ){
        var href = $('.react-swipeable-view-container div[aria-hidden="false"] a.swym-more-details-btn').attr("href");
        console.log("HAY LINK", href);   
        window.location.href = href;
      } else {
        console.log("NO HAY LINK");
      }
      // You can add your own logic here to respond to the mutation
    });
  });
  var config = { 
    attributes: true, 
    childList: true, 
    characterData: true,
    subtree: true
  };
  if(target){
    observer.observe(target, config);
  }
});

